/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useContext} from 'react';
import {FluidContainer, LargeTag, LeadList, PowerDropdown, Tag, StrongList, InputDate, Loader} from '../../../components';
import {ARMcontext} from '../../../utils/context/context';
import {Teams} from '../../../utils/api';
import {
  LightText,
  LeadSection, 
  TableSection, 
  LeadTopHeader, 
  LeadBottomHeader, 
} from './styles';

const DefaultMetrics = [
  {title: 'Internal Rotation (IR)', value: 'ir'},
  {title: 'External Rotation (ER)', value: 'er'},
  {title: 'ER : IR Ratio', value: 'ratio'},
  {title: 'Scaption', value: 'scaption'},
  {title: 'ROM Internal Rotation', value: 'rom_ir'},
  {title: 'ROM External Rotation', value: 'rom_er'},
  {title: 'Total Arc', value: 't_arc'},
];

const DefaultTimes = [
  {title: 'Last Month', value: '1_m'},
  {title: 'Last 2 Months', value: '2_m'},
  {title: 'Last 3 Months', value: '3_m'},
  {title: 'Last 4 Months', value: '4_m'},
  {title: 'Last 5 Months', value: '5_m'},
  {title: 'Last 6 Months', value: '6_m'},
  {title: 'Last 7 Months', value: '7_m'},
  {title: 'Last 8 Months', value: '8_m'},
  {title: 'Last 9 Months', value: '9_m'},
  {title: 'Last 10 Months', value: '10_m'},
  {title: 'Last 11 Months', value: '11_m'},
  {title: 'Last 12 Months', value: '12_m'},
  {title: 'Custom', value: 'custom'},
];

export default ({playersGroup, playerNameSearch}: {playersGroup: string; playerNameSearch: string}) => {
  const [times, useTimes] = useState<{title: string; value: string}>(DefaultTimes[0]);
  const [metrics, useMetrics] = useState<{title: string; value: string}>(DefaultMetrics[0]);
  const [mostImproved, useMostImproved] = useState<Array<object | any>>([]);
  const [topPlayers, useTopPlayers] = useState<Array<object | any>>([]);
  const [benchMark, useBenchMark] = useState<Array<object | any>>([]);
  const [teamRanking, useTeamRanking] = useState<any>({});
  const {selectedTeam} = useContext(ARMcontext);
  const [date, setDate] = useState(new Date());
  const [loading, useLoading] = useState(false);
  const [endDate, setEndDate] = useState(new Date());

  const TEAMS = new Teams();
  useEffect(() => {
    fetchLeaderboardData();
  }, [times, metrics, playersGroup, playerNameSearch, selectedTeam, date, endDate]);
  async function fetchLeaderboardData() {
    useLoading(true);
    const examsResponse = await TEAMS.GetLeaderboardRecords(
      selectedTeam._id,
      playersGroup,
      playerNameSearch,
      metrics.value,
      times.value,
      date,
      endDate,
    );

    if (examsResponse.status) {
      useLoading(false);
      const newImproved = examsResponse.data?.mostImprovedPlayers?.map(item => {
        item.player = examsResponse.data?.playersMap[item._id];
        return item;
      });
      const newTop = examsResponse.data?.topPlayers?.map(item => {
        item.player = examsResponse.data?.playersMap[item._id];
        return item;
      });
      useMostImproved(newImproved);
      useTopPlayers(newTop);
      useBenchMark(examsResponse?.data?.benchMark);
      useTeamRanking(examsResponse?.data?.teamRanking);
    } else {
      useLoading(false);
    }
  }

  function ChangeTimes(selectedOption: any) {
    useTimes(selectedOption);
  }
  function handlePeriodStatus() {
    useTimes(DefaultTimes[0]);
  }
  function ChangeMetrics(selectedOption: any) {
    useMetrics(selectedOption);
  }
  return (
    <FluidContainer>
      <>
        <LeadSection data-cy="lead-header">
          <>
            <div>
              <LeadTopHeader>
                <span>BENCHMARK</span>
                <span>Unit of messure</span>
                <Tag name={'Lbs'} theme={'Info'} fontSize={'11.2px'} />
              </LeadTopHeader>
              <LeadBottomHeader>
                <div>
                  <LightText>High school</LightText>
                  <LargeTag text={benchMark ? benchMark[0] : '00'} color="#ACB1C0" />
                </div>
                <div>
                  <LightText>College</LightText>
                  <LargeTag text={benchMark ? benchMark[1] : '00'} color="#5D6E81" />
                </div>
                <div>
                  <LightText>Professional</LightText>
                  <LargeTag text={benchMark ? benchMark[2] : '00'} color="#007AFF" />
                </div>
              </LeadBottomHeader>
            </div>
            <div>
              <LeadTopHeader>
                <span>TEAM RANKING</span>
              </LeadTopHeader>
              <LeadBottomHeader>
                <div>
                  <LightText>Team Average</LightText>
                  <LargeTag text={teamRanking?.avg || '00'} color="#3E464E" />
                </div>
                <div>
                  <LightText>Team Percentile</LightText>
                  <LargeTag text={teamRanking?.percentile?`${teamRanking?.percentile}%`:'0%'} color="#3E464E" />
                </div>
              </LeadBottomHeader>
            </div>
          </>
          <div>
            <div>
              <span>Metric:</span>
              <PowerDropdown
                dataCy="lead-metric-dropdown"
                theme="dark"
                search={false}
                firstActve={true}
                onClick={ChangeMetrics}
                dataArray={DefaultMetrics}
                primaryTitle={metrics.title}
                mPadding={'18px 12px 18px 12px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 11px 0 rgba(0, 0, 0, 0.09);'}
              />
            </div>
            <div>
              <span>Performance period:</span>
              {times.value === 'custom' ? (
                <div>
                  <InputDate date={date} setDate={setDate} handleStatus={handlePeriodStatus} endDate={endDate} setEndDate={setEndDate} />
                </div>
              ) : (
                <>
                  <PowerDropdown
                    dataCy="lead-performance-dropdown"
                    theme="dark"
                    search={false}
                    firstActve={true}
                    onClick={ChangeTimes}
                    dataArray={DefaultTimes}
                    primaryTitle={times.title}
                    mPadding={'18px 12px 18px 12px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 11px 0 rgba(0, 0, 0, 0.09);'}
                  />
                </>
              )}
            </div>
          </div>
        </LeadSection>
        <TableSection data-cy="lead-lists">
          {loading ? (
            <div style={{marginLeft: 'auto', marginRight: 'auto'}}>
              <Loader width="186px" height="100px" />
            </div>
          ) : (
            <>
              {mostImproved.length && topPlayers.length ? (
                <>
                  <LeadList title="MOST IMPROVED" icon="Rocket" data={mostImproved} />
                  <StrongList title="TOP PERFORMERS" icon="Trophy" data={topPlayers} />
                </>
              ) : (
                <div style={{marginLeft: 'auto', marginRight: 'auto'}}>No Data</div>
              )}
            </>
          )}
        </TableSection>
      </>
    </FluidContainer>
  );
};
